module.exports = __webpack_public_path__ + "static/media/hhLogoLight.88040bbb.png";